import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import shortid from 'shortid';
import api from 'api';
import Util from 'utility';
import Loading from 'components/Loading';
import FoodSearch from 'components/FoodSearch';
import { addFood } from 'actions/index';

function PanelAddFood({ onFoodAdded, isDrinkRegime, groupId }) {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const [foodLoading, setFoodLoading] = useState(false);
    const [currentFood, setCurrentFood] = useState(null);

    const showFoodDetail = (id) => {
        setFoodLoading(true);
        api('foods/detail/' + id).then(result => {
            setFoodLoading(false);
            setCurrentFood(result.data);
        });
    };

    const closeFoodDetail = () => {
        setFoodLoading(false);
        setCurrentFood(null);
    };

    const addToRecipe = (foodId, gid) => {
        const img_src = data.globals.myFoodIds.includes(foodId)
            ? 'https://www.zofapp.cz/data/zof/item/' + foodId + '.svg?r=' + Math.random()
            : 'https://www.zofapp.cz/data/zof/item/' + foodId + '.svg';

        const gidFinal = typeof gid !== 'undefined' ? gid : '';
        dispatch(addFood({
            id: shortid(),
            food_id: foodId,
            group_id: gidFinal,
            image: img_src,
            title: data.globals.itemData[foodId]['title'],
            weight: data.globals.itemData[foodId]['weight'],
            is_drink: 0
        }));
        Util.doLoadEvaluation();
        onFoodAdded();
    };

    let content;
    if (foodLoading) {
        content = <Loading />;
    } else if (currentFood) {
        const food = currentFood;
        let undesirableInfo = null;
        if (!Util.isNutriKucharMode(data.appMode) && data.appModeData?.undesirableFoods?.includes(food.id)) {
            undesirableInfo = <p className="flex text-[0.85em] mt-[2px] text-[#f00] [&>span]:text-[0.85em] [&>span]:mr-[0.5em] [&>span]:font-bold [&>span]:uppercase"><span>Nevhodná potravina</span></p>;
        }

        content = (
            <div>
                <button onClick={closeFoodDetail}><i className="fa fa-angle-left"></i></button>
                <div className="flex items-center my-[1em] [&>img]:w-[60px] [&>img]:h-auto [&>h1]:text-[2.2em] [&>h1]:font-bold [&>h1]:m-0 [&>h1]:ml-[2rem]" style={{ paddingTop: 0 }}>
                    <img src={`https://www.zofapp.cz/data/zof/item/${food.id}.svg`} alt="" />
                    <h1>{food.title}</h1>
                </div>
                {undesirableInfo}
                <div dangerouslySetInnerHTML={{__html: food.description}} />
            </div>
        );
    } else {
        content = <FoodSearch onClick={showFoodDetail} isEmbedded={true} isDrinkRegime={isDrinkRegime} groupId={groupId} />;
    }

    return (
        <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
            <div className="flex flex-col flex-1">
                {content}
            </div>
        </div>
    );
}

export default PanelAddFood;
